import React, { useLayoutEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { buildBreadcrumbs } from "./breadcrumbs.utils";
import { Breadcrumbs } from "@atomaro/ui-kit";
import { BreadcrumbsContainer, Services, ServiceButton, ServiceButtonText } from "./Breadcrumbs.styles";
import { useBreadcrumbsStore } from "entities/breadcrumbs";
import {Logo} from "shared/ui/icons/logo.tsx";
import {HudNavItem, IconComponent} from "widgets/hud/model/routes.ts";
import {ConfigContextType} from "../../../../app/App.tsx";

export const BreadcrumbsWrapper = ({config}: {config?: ConfigContextType}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const crumbs = useBreadcrumbsStore((s) => s.crumbs);
  const setCrumbs = useBreadcrumbsStore((s) => s.setCrumbs);

  const nextCrumbs = useMemo(() => buildBreadcrumbs(location.pathname), [location.pathname]);

  useLayoutEffect(() => {
      setCrumbs(nextCrumbs);
  }, [nextCrumbs, setCrumbs]);

  const lastIndex = crumbs.length - 1;
  
  const services: (HudNavItem & {to: string})[] = [
    {
      id: 'yourhive',
      label: 'ТвойУлей',
      icon: Logo as IconComponent,
      iconActive: Logo as IconComponent,
      to: config?.VITE_BEESHARE_HOST ? config.VITE_BEESHARE_HOST : '/breeding-portal',
      match: 'exact',
      iconActiveFill: 'rgba(255, 79, 18, 1)',
    },
    {
      id: 'selportal',
      label: 'Селекционный портал',
      icon: Logo as IconComponent,
      iconActive: Logo as IconComponent,
      to: '/breeding-portal',
      match: 'exact',
      iconActiveFill: 'rgba(255, 79, 18, 1)',
    },
    {
      id: 'honeyexchange',
      label: 'Биржа меда',
      icon: Logo as IconComponent,
      iconActive: Logo as IconComponent,
      to: '/honey-exchange',
      match: 'exact',
      iconActiveFill: 'rgba(255, 79, 18, 1)',
    },
  ];

  return (
    <BreadcrumbsContainer>
      <Breadcrumbs key={location.pathname} size="s" variant="primary">
        {crumbs.map((c, i) => {
          if (i === lastIndex) return <span key={c.route.path + i}>{c.title}</span>

          return (
            <span
              key={c.route.path + i}
              role="link"
              tabIndex={0}
              onClick={() => navigate(c.url)}
              onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") navigate(c.url);
              }}
              style={{ cursor: "pointer" }}
            >
              {c.title}
            </span>
          )
        })}
      </Breadcrumbs>
      <Services>
        {/*<Breadcrumbs>*/}
        {/*  {services.map((item) => {*/}
        {/*    // const Icon = item.icon;*/}
        {/*    */}
        {/*    return (*/}
        {/*      <span style={{ cursor: "pointer"}}>*/}
        {/*        <a style={{color: 'light-dark(#101828, #E8E8EE)'}} href={item.to} title={item.label} target="_blank">{item.label}</a>*/}
        {/*      </span>*/}
        {/*      // <ServiceButton>*/}
        {/*      //   <Icon height={16}/>*/}
        {/*      //   <ServiceButtonText style={{ display: "flex", alignItems: "center" }}>*/}
        {/*      //*/}
        {/*      //   </ServiceButtonText>*/}
        {/*      // </ServiceButton>*/}
        {/*      */}
        {/*      // <HudButton key={item.id} item={item} aria-label={item.label} noCollapse />*/}
        {/*    );*/}
        {/*  })}*/}
        {/*</Breadcrumbs>*/}
        {services.map((item) => {
          const Icon = item.icon;
          
          return (
            <ServiceButton>
              <Icon height={16} fill={(item.id === 'selportal' || item.id === 'honeyexchange') ? '#858fa3' : 'rgb(255,79,18)'}/>
              <ServiceButtonText style={{ display: "flex", alignItems: "center" }}>
                <a href={item.to} title={item.label} target="_blank">
                  {item.label}
                </a>
              </ServiceButtonText>
            </ServiceButton>
            
            // <HudButton key={item.id} item={item} aria-label={item.label} noCollapse />
          );
        })}
      </Services>
    </BreadcrumbsContainer>
  );
};
